var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 0.25C3.41016 0.25 3.9375 0.777344 3.9375 1.375V3.0625C3.9375 4.64453 5.16797 5.875 6.75 5.875C8.29688 5.875 9.5625 4.64453 9.5625 3.0625V1.375C9.5625 0.777344 10.0547 0.25 10.6875 0.25C11.2852 0.25 11.8125 0.777344 11.8125 1.375V2.5C11.8125 3.69531 11.8828 4.67969 12.0234 5.52344L0 14.1016V10.1992C0 9.60156 0.210938 9.00391 0.492188 8.51172C0.984375 7.5625 1.6875 5.69922 1.6875 2.5V1.375C1.6875 0.777344 2.17969 0.25 2.8125 0.25ZM0.105469 16.7734L12.6562 7.80859C12.7617 8.08984 12.8672 8.30078 12.9727 8.47656C13.2539 9.00391 13.5 9.60156 13.5 10.1992V16C13.5 17.2656 12.4805 18.25 11.25 18.25H2.25C1.26562 18.25 0.421875 17.6523 0.105469 16.7734Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default ForwardRef;